import React from 'react';
import { BeatLoader } from 'react-spinners';

const CommonLoader = () => {
  return (
    <div className="flex w-full justify-center">
      <BeatLoader className="pt-2" color="#c64002" />
    </div>
  );
};

export default CommonLoader;
